import { Routes } from "@angular/router";
import { AdvertisingListComponent } from "./advertising-list/advertising-list.component";
import { AdvertisingCreateComponent } from "./advertising-create/advertising-create.component";
import { AdvertisingEditComponent } from "./advertising-edit/advertising-edit.component";
import { AdvertisingDeleteComponent } from "./advertising-delete/advertising-delete.component";
import { AdvertisingDetailsComponent } from "./advertising-details/advertising-details.component";
import { actionsGuard } from "../shared/guards/actions.guard";

export const advertisingRoutes: Routes = [
  { path: '', redirectTo: 'list', pathMatch: 'full' },
  { path: 'list', component: AdvertisingListComponent, canActivate: [actionsGuard] },
  { path: 'create', component: AdvertisingCreateComponent, canActivate: [actionsGuard] },
  { path: 'edit/:id', component: AdvertisingEditComponent, canActivate: [actionsGuard] },
  { path: 'delete/:id', component: AdvertisingDeleteComponent, canActivate: [actionsGuard] },
  { path: 'details/:id', component: AdvertisingDetailsComponent, canActivate: [actionsGuard] },
]
